export default __webpack_public_path__ + "../staticImages/sprite-hermes-2x.png";